/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is it different from a box plot?`)
};

const es_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué se diferencia de un diagrama de caja?`)
};

const de_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie unterscheidet er sich von einem Boxplot?`)
};

const nl_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe verschilt het van een boxplot?`)
};

const fr_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En quoi diffère-t-il d'un box plot ?`)
};

const it_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cosa è diverso da un box plot?`)
};

const pt_br2_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que ele difere de um box plot?`)
};

const pt_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que difere de um box plot?`)
};

const ja_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱ひげ図とどう違いますか?`)
};

const zh_violin_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它与箱形图有什么不同？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_faq_q2", locale)
	if (locale === "en") return en_violin_faq_q2(inputs)
	if (locale === "es") return es_violin_faq_q2(inputs)
	if (locale === "de") return de_violin_faq_q2(inputs)
	if (locale === "nl") return nl_violin_faq_q2(inputs)
	if (locale === "fr") return fr_violin_faq_q2(inputs)
	if (locale === "it") return it_violin_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_violin_faq_q2(inputs)
	if (locale === "pt") return pt_violin_faq_q2(inputs)
	if (locale === "ja") return ja_violin_faq_q2(inputs)
	return zh_violin_faq_q2(inputs)
};